import { Text, FlexProps, Flex, VvsTrophyIcon } from 'vvs-uikit'
import { Mole } from 'state/vvsgotchi/models'
import { useTranslation } from 'contexts/Localization'
import { ContextApi } from 'contexts/Localization/types'
import PixelatedImage from 'views/VvsGotchi/components/PixelatedImage'
import HealthIconImage from 'views/VvsGotchi/components/HealthIconImage'
import { tierToIcon, tierToIconSize, HEALTH_LEVEL_VALUES } from 'views/VvsGotchi/config'
import withRankSuffix from 'utils/rankSuffix'

import { MoleAvatar, EllipsisText } from '../styles'
import { MoleCardWrapper, CardRow, CardLabel, BadgeWrapper } from './styles'

interface MoleCardProps extends Pick<FlexProps, 'onClick'> {
  mole: Mole
  disabled?: boolean
}
const MoleCard: React.FC<MoleCardProps> = ({ mole, onClick, disabled }) => {
  const { t } = useTranslation()
  const { tier, imageUrl, isStaked, name, health, rank } = mole
  const badgeSrc = tierToIcon[tier]

  return (
    <MoleCardWrapper onClick={onClick} disabled={disabled}>
      <CardRow>
        <MoleAvatar size="120px" image={imageUrl} pixelated>
          <BadgeWrapper>
            {badgeSrc && (
              <Flex alignItems="end" height="30px">
                <PixelatedImage src={badgeSrc} width={tierToIconSize[tier].md} />
              </Flex>
            )}
            {isStaked && <PixelatedImage src="/images/vvsGotchi/staked.png" whenRetina />}
          </BadgeWrapper>
        </MoleAvatar>
      </CardRow>
      <CardLabel px="8px" py="12px" background="white">
        <EllipsisText bold fontSize="13px" color="black">
          {name}
        </EllipsisText>
      </CardLabel>
      <CardLabel p="8px">
        <Flex gap="4px" alignItems="center">
          {typeof health === 'number' && <HealthIconImage health={health} size="10px" />}
          <Text color="darkestNightBlue" fontSize="11px">
            {getHealthStatus(health, t)}
          </Text>
        </Flex>
        <Text color="darkestNightBlue" bold>
          {health}
        </Text>
      </CardLabel>
      <CardLabel p="8px" background="lightgray">
        <Flex gap="4px" alignItems="center">
          <VvsTrophyIcon />
          <Text fontSize="13px" bold color="black">
            {typeof rank === 'number' ? withRankSuffix(rank) : '-'}
          </Text>
        </Flex>
      </CardLabel>
    </MoleCardWrapper>
  )
}

export default MoleCard

const getHealthStatus = (health: number, t: ContextApi['t']) => {
  if (health >= HEALTH_LEVEL_VALUES.excellent) return t('Excellent')
  if (health >= HEALTH_LEVEL_VALUES.healthy) return t('Healthy')
  if (health >= HEALTH_LEVEL_VALUES.normal) return t('Normal')
  if (health >= HEALTH_LEVEL_VALUES.unhealthy) return t('Unhealthy')
  return t('Sick') // HEALTH_LEVEL_VALUES.sick
}
